import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WorkoutHistory from "./WorkoutHistory";
import PersonalStats from "./PersonalStats";
import {
  fetchWorkoutHistory,
  fetchPersonalStats,
} from "../services/apiService";
import { useAuth } from "../../context/AuthContext";

const Dashboard = () => {
  const [userToken, setUserToken] = useState(null);
  const [workoutHistory, setWorkoutHistory] = useState([]);
  const [personalStats, setPersonalStats] = useState(null);
  const [activeScreen, setActiveScreen] = useState("personalStats");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();

  useEffect(() => {
    if (authLoading) return;
    if (user?.uid) {
      setUserToken(user.uid);
      loadUserData(user.uid);
    } else {
      navigate("/login");
    }
  }, [navigate, user?.uid, authLoading]);

  const loadUserData = async (token) => {
    try {
      setLoading(true);
      setError(null);
      
      const [workouts, stats] = await Promise.all([
        fetchWorkoutHistory(token),
        fetchPersonalStats(token)
      ]);

      setWorkoutHistory(workouts);
      setPersonalStats(stats);
    } catch (error) {
      console.error("Error loading user data:", error);
      setError("Failed to load user data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const refreshData = () => {
    if (userToken) {
      loadUserData(userToken);
    }
  };

  const renderScreen = () => {
    if (loading) {
      return <div className="loading">Loading...</div>;
    }

    if (error) {
      return (
        <div className="error">
          <p>{error}</p>
          <button onClick={refreshData} className="retry-button">
            Retry
          </button>
        </div>
      );
    }

    switch (activeScreen) {
      case "personalStats":
        return <PersonalStats data={personalStats} onUpdate={refreshData} />;
      case "workoutHistory":
        return <WorkoutHistory data={workoutHistory} userId={userToken} onUpdate={refreshData} />;
      default:
        return <div>No Screen Selected</div>;
    }
  };

  return (
    <div className="dashboard">
      <h2 className="dashboard-title">Dashboard</h2>
      <div className="dashboard-sections">{renderScreen()}</div>
      <div className="navigation-buttons">
        <button
          className={`dashboard-button ${activeScreen === "personalStats" ? "active" : ""}`}
          onClick={() => setActiveScreen("personalStats")}
        >
          Personal Stats
        </button>
        <button
          className={`dashboard-button ${activeScreen === "workoutHistory" ? "active" : ""}`}
          onClick={() => setActiveScreen("workoutHistory")}
        >
          Workout History
        </button>
      </div>
    </div>
  );
};

export default Dashboard;
